module.exports = __webpack_public_path__ + "img/fitted-mask-loops-hero.5e611b0d.jpg";